//Jquery Start
(function($) {
	// Mobile toogle menu
	$('.mobilelistnav .mob_submenu').after('<div class="sub_menu_btn burslines_menu"><span class="line"></span><span class="line"></span></div>');
	$('.sub_menu_btn').on('click', function(){
		$(this).toggleClass('close_sub_menu');
		$(this).prev('ul').stop().slideToggle();
		$(this).parent().toggleClass('openlist');
	});
	//Target Window Open
	$('.open_target').on('click', function(){
		$($(this).data('target')).fadeIn().addClass('show');
		$(this).addClass('show');
		return false;
	})
	$('.close_target').on('click', function(){
		$($(this).data('target')).removeClass('show').fadeOut();
		$('.open_target, .mobilebtn').removeClass('show');
		$('body').removeClass('scroll-hidden');
		return false;
	})	
	$('.mobilebtn').on('click', function(){
		if($(this).hasClass('show')){
			$($(this).data('target')).removeClass('show').fadeOut()
			$(this).removeClass('show');
			$('body').removeClass('scroll-hidden');
		}else{
			$($(this).data('target')).fadeIn().addClass('show');
			$(this).addClass('show');
			$('body').addClass('scroll-hidden');
		}
		return false;
	});
    //Sticky head
	// navbar fixed scrolling
    $(window).on("scroll",function () {
		let bodyScroll =  $(window).scrollTop();
		let	navbar = $(".header-sticky");
		if(bodyScroll > 5){
			navbar.addClass("header_appear");
		}else{
			navbar.removeClass("header_appear");
		}
	});
	//header counter custom update
	$(".add-to-cart-button").click(function(){
		setTimeout(function() {
			jQuery.getJSON('/cart/update.js', function(cart) {
				if(cart.item_count > 0) {
					$("span.cart-counter").removeClass('hidden');
					$("span.cart-counter").html(cart.item_count);
				}
			}); 
		}, 700);
	 });
	 //Header search toogle window
	 $('.head-search-btns svg.icon').on('click', function(){
		if($(this).hasClass('modal__toggle-open')){
			$('details-modal.header__search').addClass('show');
			$(this).addClass('hidden')
		}else{
			$('details-modal.header__search').removeClass('show');
			$('.modal__toggle-open').removeClass('hidden')
		}
	 });
if ($('.wrapper-imageslider').length > 0) { 
$('.wrapper-imageslider').zoom(); 
}
  
})(jQuery); //END jQuery